module.exports = __webpack_public_path__ + "media/images/master-favicon-1f859cd8.png";